<template>
    <div>
        <Breadcrumbs main="Services" title="Complaints"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="user-profile">
              <div class="row">
                <div class="col-lg-8 offset-lg-2">
                  <div class="card">
                    <div v-if="loading" class="loader-12"></div>
                      <div class="card-body">
                        <section v-show="step == 1">
                            <h6>Dear Customer,</h6>
                            <p>Kindly select from the list of complaints below in order for us to assist you.</p>
                            <div class="my-4 row">
                              <label class="col-sm-3 col-form-label">Select Complaints <span class="text-danger">*</span></label>
                              <div class="col-sm-9 col-xl-7">
                                  <select placeholder="Select Complaints *" v-model="form.complaintType" class="form-control acct-num" required="required">
                                      <option value="">Select Complaints </option>
                                      <option v-for="complaint in allComplaints" :key="complaint.id" :value="complaint.id">{{complaint.name}}</option>
                                  </select>
                              </div>
                          </div>
                          <section class="animated fadeIn">
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="address1">Description<span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <textarea class="form-control" v-model="form.message" placeholder="Description" type="text" />
                                  </div>
                              </div>
                              <section v-if="form.complaintType !== 8" class="animated fadeIn">
                                <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label">Amount in dispute <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <input min="0" @change="formatInput" @paste.prevent @keypress="isNumber" @keyup="formatNum" v-model="form.amountInDispute" class="form-control" data-val-number="The field Amount must be a number." data-val-required="The Amount field is required." id="Amount" name="Amount" placeholder="Enter Amount *" required="required" type="text" value="" />
                                  </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label" for="address1">Transaction in Reference<span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <input class="form-control" v-model="form.transactionReference" placeholder="Reference" type="text" />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label" for="endDate">Transaction Date <span class="text-danger">*</span></label>
                                        <div class="col-sm-9 col-xl-7">
                                            <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="feather icon-calendar text-danger"></i></span>
                                                <datepicker placeholder="Transaction Date" input-class="datepicker-here form-control calendar-input digits" v-model="form.transactionDate" :format="format"></datepicker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                              </section>
                              
                              <div class="pt-2 row">
                                  <div class="col-sm-9 offset-lg-3 offset-sm-0">
                                      <button type="button" @click="submitComplaint" class="btn btn-danger">Submit <i class="fa fa-save"></i></button>
                                  </div>
                              </div>
                          </section>
                        </section>
                          
                        <!-- Request Success Response -->
                        <div id="RequestSuccessResponseSection" class="animated fadeIn mt-4 mb-5" v-show="step === 2">
                          <div class="card-content pt-2 pl-3 pb-2 pr-3">
                              <div class="p-2 text-center">
                                  <img src="@/assets/TAJimages/notification/success.png" alt="Error Icon image" class="img-fluid" />
                                  <h5 class="text-bold-700 mb-2 text-success"><i class="feather icon-check-circle fa-2x"></i> COMPLAINT LOGGED SUCCESSFULLY!</h5>
                                  <p id="SuccessMessage">Your complaints has be logged successfully!</p>
                                  <p class="mt-4">
                                    <router-link to="/dashboard/default"><a class="btn btn-outline-danger btn-round ml-2">Go home <i class="fa fa-home"></i></a></router-link>
                                  </p>
                              </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    <!-- Container-fluid Ends-->
    </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import { mapActions } from 'vuex';
  import moment from 'moment';
  export default {
    name: 'Complaints',
    components: {
      Datepicker
    },
    data:()=>({
      format: 'dd-MM-yyyy',
      form: {
        title: 'Complaints',
        customerId: 'test',
        amountInDispute: '0.00',
        message: '',
        transactionDate: '',
        complaintType: '',
        transactionReference: '',
        platform: 1
      },
      loading: false,
      step: 1,
      allComplaints: [
        { id: 1, name: 'Account Transaction Alert' },
        { id: 2, name: 'Account Usage' },
        { id: 3, name: 'ATM Dispense Error' },
        { id: 4, name: 'ATM Card Usage' },
        { id: 5, name: 'Failed ATM Card Transaction On ATM, POS, WEB' },
        { id: 6, name: 'Failed Funds Transfer TAJBank' },
        { id: 7, name: 'Failed Funds Transfer Other Bank' },
        { id: 8, name: 'Internet Mobile USSD Banking Usage' },
        { id: 9, name: 'Fraud Related' },
        { id: 10, name: 'Bill Payment Or Airtime' },
        { id: 11, name: 'Charges And Fees' },
        { id: 12, name: 'Others' }
      ]
    }),
    computed: {
    },
    methods: {
      ...mapActions('requests', ['createComplaint']),
      async submitComplaint() {
        try {
          if(this.form.message === '' || this.form.amountInDispute === '' || this.form.transactionDate === '' || this.form.complaintType === '') {
            this.$swal({
              title: 'Oops...',
              text: 'Please fill all the required fields',
              type: 'error',
              confirmButtonText: 'Ok'
            });
          } else {
            this.loading = true;
            const data = {
              ...this.form,
              amountInDispute: Number(this.form.amountInDispute.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
              transactionDate: this.form.transactionDate = moment(this.form.transactionDate).format('YYYY-MM-DD')
            };
            await this.createComplaint({ data });
            this.loading = false;
            this.step = 2;
            this.clearForm();
          } 
        } catch(error) {
          this.loading = false;
          this.$swal({
            title: 'Oops...',
            text: error.response.data.errors[0],
            type: 'error',
            confirmButtonText: 'Ok',
          });
        }
      },
      formatInput(event) {
        this.form.amountInDispute = event.target.value;
        const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
        this.form.amountInDispute = formatter.format(this.form.amountInDispute.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
      },
      formatNum(event) {
        if(this.form.amountInDispute === '') {
          this.form.amountInDispute = '0.00';
        } else {
          this.form.amountInDispute = event.target.value;
          const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
          this.form.amountInDispute = formatter.format(this.form.amountInDispute.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
        }
        if(event.key === 'Backspace' || event.key === 'Delete') {
          if(event.target.value.length <= 4) {
            const formatter = new Intl.NumberFormat('en-US');
            this.form.amountInDispute = formatter.format(this.form.amountInDispute.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
            if(event.target.value.length < 2) {
              this.form.amountInDispute = '0.00';
            }
          } else {
            const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
            this.form.amountInDispute = formatter.format(this.form.amountInDispute.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
            return;
          }
        }	
        // if(event.target.value.length === 2)    event.target.value = '0.00';
      },
      // CLEAR FORM
      clearForm() {
        this.form.amountInDispute = '0.00';
        this.form.message = '';
        this.form.transactionDate = '';
        this.form.complaintType = '';
        this.form.transactionReference = '';
      }
    }
  };
</script>
<style scoped>
.vdp-datepicker{
  width: 324px !important;
  max-width: 400px !important; 
}
</style>